import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ArrowRightOutlined from '@material-ui/icons/ArrowRightOutlined';
import ArrowLeftOutlined from '@material-ui/icons/ArrowLeftOutlined';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import WarningIcon from '@material-ui/icons/Warning';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import Zoom from '@material-ui/core/Zoom';
import ResultPaymentOption from './ResultPaymentOption';

class ResultPage extends React.Component {

    results = [];
    widgetConfig = this.props.widgetConfig;

    constructor(props) {
        super(props);
        this.state.ratesEffectiveNotice = props.state.ratesEffectiveNotice;
        this.state.legalDisclaimer = props.state.legalDisclaimer;
        this.state.results = props.state.results;
        if (props.state.results.length > 0) {
            this.state.preferred = props.state.results[0];
        }
    }

    preferredAssumptions() {
        
        var params = this.props.state;

        var rawMarkup = `<div>${this.widgetConfig.assumptionsText}</div>`;

        var currFormat = new Intl.NumberFormat('en-US', { currency: 'USD', style: 'currency'});

        rawMarkup = rawMarkup.replace(/\[PurchasePrice\]/g, currFormat.format(params.homeValue));
        rawMarkup = rawMarkup.replace(/\[DownPayment\]/g, currFormat.format(params.downPayment));
        rawMarkup = rawMarkup.replace(/\[LoanAmount\]/g, currFormat.format(params.homeValue - params.downPayment));


        rawMarkup = this.state.ratesEffectiveNotice + "<br /><br />" + rawMarkup;
        return { __html: rawMarkup };
    }

    state = {
        page: 'preferred',
        results : [],
        preferred: null,
        legalDisclaimer: null,
        ratesEffectiveNotice: null,
    }

    componentDidMount() {

        let state = {...this.state }

        if (!this.state.preferred) {
            state.page = 'noresults';
        }
        
        this.setState(state);
    }

    render() {

        return (
            <div className={`mam-result-page`}>
                { this.widgetConfig && 
                    <div>
                        { this.state.page === 'noresults' &&
                            <Slide in={true} direction="up" timeout={500}>
                                <div className={`mam-result-noresults`}>
                                    <WarningIcon />
                                    <div>
                                        Sorry, we don't have any loan options available at this time for these amounts
                                    </div>
                                    <div>
                                        Most loan options require at least 3% of the home value as a down payment. Try a larger down payment and try again.
                                    </div>
                                </div>
                            </Slide>
                        }
                        { this.state.preferred && this.state.page === 'preferred' && 
                            <Zoom in={true} direction="right" timeout={500}>
                                <div className={`mam-result-preferred`}>

                                    <div className={`mam-result-label-pandi`}>
                                        <div>Monthly Principal and Interest Payment</div>
                                        <InfoIcon fontSize="small" />
                                    </div>

                                    <div className={`mam-result-value-pandi`}>
                                        {this.props.formatCurrency(this.state.preferred.Payment)}
                                    </div>

                                    <div className={`mam-result-preferred-label-rateandapr`}>Rate / APR</div>
                                    <div className={`mam-result-preferred-value-rateandapr`}>
                                        { Math.floor(this.state.preferred.Rate) == this.state.preferred.Rate && this.state.preferred.Rate.toFixed(1) }
                                        { Math.floor(this.state.preferred.Rate) != this.state.preferred.Rate && this.state.preferred.Rate.toFixed(3) }
                                        <span>% / {this.state.preferred.APR.toFixed(3)}%</span>
                                    </div>

                                    <div className={`mam-result-preferred-label-mortgageType`}>Mortgage Type</div>
                                    <div className={`mam-result-preferred-value-mortgageType`}>
                                        {this.state.preferred.Product}
                                    </div>

                                    <div className={`mam-result-preferred-learn-more`}>
                                        <Button
                                                variant="contained"
                                                color="primary"
                                                className={`mam-btn mam-learn-more`}
                                                onClick={() => this.props.learnMore(this.state.preferred.Product)}
                                            > {this.widgetConfig.linkText}
                                        </Button>
                                    </div>
                                    <div className={`mam-result-links`}>
                                        <div className={`mam-result-legalDisclaimer`} onClick={() => this.setState({page:'legalDisclaimer'})}>
                                            <InfoIcon fontSize="small" />
                                            <div>Important Assumptions</div>
                                        </div>
                                        <div className={`mam-result-moreOptions`} onClick={() => this.setState({page:'moreOptions'})}>
                                            <ArrowRightOutlined fontSize="small" />
                                            <div>More Payments</div>
                                        </div>
                                    </div>
                                </div>
                            </Zoom>
                        }

                        { this.state.page === 'legalDisclaimer' && 
                            <Slide in={true} direction="left">
                                <div className={`mam-legalDisclaimer`}>
                                    <div>Important Assumptions</div>
                                    <div dangerouslySetInnerHTML={this.preferredAssumptions()}></div>
                                    <div onClick={() => this.setState({page:'preferred'})}>
                                        <ArrowLeftOutlined fontSize="small" /><div>Back</div>
                                    </div>
                                </div>
                            </Slide>
                        }      

                        { this.state.page === 'moreOptions' && 
                            <Slide in={true} direction="left">
                                <div className={`mam-moreOptions`}>
                                    <div className={`mam-moreOptions-products`}>
                                        <div className={`mam-moreOptions-head`}>
                                            <div className={`mam-payment-option-label-product`}>Product</div>
                                            <div className={`mam-payment-option-label-rate`}>Rate</div>
                                            <div className={`mam-payment-option-label-apr`}>APR</div>
                                            <div className={`mam-payment-option-label-payment`}>
                                                Payment
                                                <InfoIcon style={{ float: "left", marginLeft: '5px' }} fontSize="small" />
                                            </div>
                                        </div>
                                        <div className={`mam-moreOptions-body`}>
                                            { this.state.results.map((result, index) => {
                                                return <ResultPaymentOption key={result.Product} formatCurrency={this.props.formatCurrency} paymentOption={result} />
                                            })}
                                        </div>
                                    </div>
                                    <div className={`mam-moreOptions-links`}>
                                        <div className={`mam-moreOptions-link-back`} onClick={() => this.setState({page:'preferred'})}>
                                            <ArrowLeftOutlined fontSize="small" /><div>Back</div>
                                        </div>
                                        <div className={`mam-moreOptions-link-assumptions`} onClick={() => this.setState({page:'legalDisclaimer'})}>
                                            <InfoIcon fontSize="small" /><div>Important Assumptions</div>
                                        </div>
                                    </div>
                                </div>
                            </Slide>
                        }        
                    </div> 
                }
            </div>
        );
    }
}

ResultPage.propTypes = {
    reset: PropTypes.func.isRequired,
};

const styles = theme => ({
});

export default withStyles(styles)(ResultPage);